module.exports = __webpack_public_path__ + "img/ac383f1.webp";